import {
    Directive,
    HostListener,
    Input,
    Output,
    EventEmitter,
    OnInit,
    OnChanges,
    ChangeDetectorRef
  } from '@angular/core';
  import { Subject } from 'rxjs/Subject';
  import { Subscription } from 'rxjs/Subscription';
  import { Component as IcsComponent, Property } from 'immutable-ics';
  import { saveAs } from 'file-saver/FileSaver';
  import { Calendar } from '../utils/Calendar';
  import { CalendarEvent } from '../utils/CalendarEvent';
  import * as JSzip from 'jszip';
export class CalendarExportDirective implements OnInit, OnChanges {

    
    calendars: Calendar[];

     refresh: Subject<any>;

    icsCalendars: any[]= [];

    zip: JSzip;

    refreshSubscription: Subscription;
constructor() {}
/**
 * @return {?}
 */
ngOnInit() {
        if (this.refresh) {
          this.refreshSubscription = this.refresh.subscribe(() => {
            this.refreshCalendars();
          });
        }
    }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: any): void {
      if (changes.calendars) {
        this.refreshCalendars();
      }
    }
/**
 * @return {?}
 */
export() {
          this.zip.generateAsync({type: 'blob'}).then(b => {
            saveAs(b, 'calendars.zip');
          }, function (err) {
            console.log(err);
          });
    }
/**
 * @return {?}
 */
refreshCalendars() {
      this.zip = new JSzip();
      this.icsCalendars = this.calendars.map(calendar => {
          const /** @type {?} */ ics = new IcsComponent({
            name: 'VCALENDAR',
            properties: [
              new Property({ name: 'VERSION', value: 2 }),
              new Property({ name: 'PRODID', value: 'EasyLocatus'})
            ],
            components: this.refreshEvents(calendar)
          });
          this.zip.file(calendar.name + '.ics', ics.toString());
      });
    }
/**
 * @param {?} calendar
 * @return {?}
 */
refreshEvents(calendar) {
        return calendar.events.map(event => {
          return new IcsComponent({
            name: 'VEVENT',
            properties: [
              new Property({
                name: 'DTSTART',
                value: event.start
              }),
              new Property({
                name: 'DTEND',
                value: event.end
              }),
              new Property({
                name: 'SUMMARY',
                value: event.title
              }),
            ]
          });
        });
    }
/**
 * @hidden
 * @return {?}
 */
onClick(): void {
      this.export();
    }
  static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[appCalendarExport]'
  }, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'calendars': [{ type: Input },],
'refresh': [{ type: Input },],
'onClick': [{ type: HostListener, args: ['click', ] },],
};
}

function CalendarExportDirective_tsickle_Closure_declarations() {
/** @type {?} */
CalendarExportDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CalendarExportDirective.ctorParameters;
/** @type {?} */
CalendarExportDirective.propDecorators;
/** @type {?} */
CalendarExportDirective.prototype.calendars;
/** @type {?} */
CalendarExportDirective.prototype.refresh;
/** @type {?} */
CalendarExportDirective.prototype.icsCalendars;
/** @type {?} */
CalendarExportDirective.prototype.zip;
/** @type {?} */
CalendarExportDirective.prototype.refreshSubscription;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
